module.exports = __webpack_public_path__ + "img/cases-brand-16-cover.de49f3ea.png";